import type { EventCreate, EventUpdate, EventView } from '@messe/shared'
import { apiRequest } from './api.js'

export type { EventView }

export function listEvents(includeInactive = false): Promise<EventView[]> {
  const suffix = includeInactive ? '?includeInactive=true' : ''
  return apiRequest<EventView[]>(`/events${suffix}`)
}

export function createEvent(input: EventCreate): Promise<EventView> {
  return apiRequest<EventView>('/events', { method: 'POST', body: input })
}

export function updateEvent(id: string, changes: EventUpdate): Promise<EventView> {
  return apiRequest<EventView>(`/events/${id}`, { method: 'PATCH', body: changes })
}

export async function deleteEvent(id: string): Promise<void> {
  // 204, so there is nothing to return.
  await apiRequest<undefined>(`/events/${id}`, { method: 'DELETE' })
}
